import apiClient from '../axios';

export const BRANCH_API = {
    ENDPOINTS: {
        SAVE_NEW_BRANCH: 'v1/admin/save-branch',
        FETCH_SHOP_BRANCHES: 'v1/admin/shop-branches',
        FETCH_BRANCH_DETAILS: 'v1/admin/branch-details',
        UPDATE_BRANCH: 'v1/admin/update-branch',
    },

    async createBranch(branchData) {
        try {
            const authToken = localStorage.getItem('auth_token');
            if (!authToken) throw new Error('Authentication token not found');
            if (!branchData) {
                throw new Error('Branch data is required');
            }
            const response = await apiClient.post(
                this.ENDPOINTS.SAVE_NEW_BRANCH,
                branchData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );
            if (!response.data) {
                throw new Error('No data received from server');
            }
            if (response.data.success === false) {
                throw new Error(response.data.message || 'Failed to create branch');
            }
            return response.data;
        } catch (error) {
            console.error('[BranchService] Error creating branch:', error);
            throw this._enhanceError(error, 'Failed to create branch');
        }
    },

    async fetchBranches() {
        try {
            const authToken = localStorage.getItem('auth_token');
            if (!authToken) throw new Error('Authentication token not found');
            const response = await apiClient.get(this.ENDPOINTS.FETCH_SHOP_BRANCHES, {
                headers: {
                    Authorization: `Bearer ${authToken}`
                }
            });
            if (!response.data?.success) {
                throw new Error(response.data?.message || 'Failed to fetch branches');
            }
            return response.data;
        } catch (error) {
            console.error('[BranchService] Error fetching branches:', error);
            throw this._enhanceError(error, 'Failed to fetch branches');
        }
    },

    async fetchBranchDetails(branchName) {
        try {
            const authToken = localStorage.getItem('auth_token');
            if (!authToken) throw new Error('Authentication token not found');
            if (!branchName) {
                throw new Error('Branch name is required');
            }
            const response = await apiClient.get(
                `${this.ENDPOINTS.FETCH_BRANCH_DETAILS}/${branchName}`,
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response;
        } catch (error) {
            console.error(error);
            throw this._enhanceError(error);
        }
    },

    async updateBranchApi(branchData) {
        try {
            const authToken = localStorage.getItem('auth_token');
            if (!authToken) throw new Error('Authentication token not found');
            if (!branchData) {
                throw new Error('Branch data is required');
            }
            if (!branchData.branch_id) {
                throw new Error('Branch ID is required for update');
            }

            const response = await apiClient.put(
                this.ENDPOINTS.UPDATE_BRANCH,
                branchData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`
                    }
                }
            );

            if (!response.data) {
                throw new Error('No data received from server');
            }

            if (response.data.success === false) {
                throw new Error(response.data.message || 'Failed to update branch');
            }

            return response;
        } catch (error) {
            console.error('[BranchService] Error updating branch:', error);
            throw this._enhanceError(error, 'Failed to update branch');
        }
    },

    _enhanceError(error, defaultMessage) {
        const enhancedError = new Error(
            error.response?.data?.message ||
            error.message ||
            defaultMessage
        );
        enhancedError.response = error.response;
        enhancedError.status = error.response?.status;
        enhancedError.isApiError = true;
        return enhancedError;
    }
};